/////////////////////////////////
// Определяем рабочие переменные:
var ongPageAnimationHandlers = {},
ongPageExecParams = {},
ongPageExecFuncs = {},
ongPageInitFuncs = {};

///////////////////////////////////////////////////////////////////////
// Определяем задачи при полной загрузке страницы для текущего шаблона.
jQuery(document).ready(function(event)
{
	//////////////////
	// Init Shadowbox.
	Shadowbox.init(
	{
		handleOversize: "resize",
		overlayOpacity: 0.8,
		modal: false
	});

	//////////////////////////////////////////////////////////////////////
	// Проверяем наличие правил по запуску функций инициализации страницы.
	if (typeof($('#ongAlterBodyBlock').data('ong_init_exec_funcs')) !== 'undefined')
	{
		var execFuncs = $('#ongAlterBodyBlock').data('ong_init_exec_funcs').split(':');

		//////////////////////////////////////////////////////////////////////////////
		// Если обнаружен список функций для запуска, то производим их поиск и запуск.
		if (execFuncs && typeof(execFuncs) === 'object' && execFuncs.length > 0)
		{
			for (var i = 0; i < execFuncs.length; i++)
			{
				if (typeof(ongPageInitFuncs[execFuncs[i]]) === 'function')
				{
					ongPageInitFuncs[execFuncs[i]]();
				}
			}
		}
	}

	//////////////////////////////////////////////////////////
	// Определяем триггер срабатывания нажатия кнопку скролла.
	$('body').on('click', '.scrollToButton', function(event)
	{
		////////////////////////////////////////////////////
		// Проверяем, что у элемента определен целевой блок. 
		if (typeof($(this).data('ong_scroll_target')) != 'undefined')
		{
			event.preventDefault();
			var pageTarget = $(this).data('ong_scroll_target');

			///////////////////////////////////////////
			// Определяем координаты до целевого блока.
			if ($('#'+pageTarget).hasClass('ongPageLanding') && typeof(ongPageExecParams['pg_landing_block_coords']) != 'undefined' && typeof(ongPageExecParams['pg_landing_block_coords'][pageTarget]) != 'undefined')
			{
				var pageTargetPos = ongPageExecParams['pg_landing_block_coords'][pageTarget];
			}
			else
			{
				var pageTargetPos = $('#'+pageTarget).offset().top;
			}

			///////////////////////////////////////////////////
			// Производим прокрутку страницы до целевого блока.
			if (typeof($(this).data('ong_scroll_speed')) && $(this).data('ong_scroll_speed') == 'immediately')
			{
				window.scrollTo(0, pageTargetPos); 
			}
			else
			{
				$('html,body').scrollTo(0, pageTargetPos); 
			}
		}
	});

  	/////////////////////////////////////////////////////////////
  	// Метод определения отображения текущих элементов на экране.
  	function checkIfElemInView() 
  	{
  		var window_height = $(window).height();
  		var window_top_position = $(window).scrollTop();
  		var window_bottom_position = (window_top_position + window_height);

		////////////////////////////////////////////////////////////////////////////
		// Производим определение позиции каждого отслеживаемого эелемента страницы.
		$.each($('.ongScrollControll'), function() 
		{
			var element = $(this);
			var element_height = element.outerHeight();
			var element_top_position = element.offset().top;
			var element_bottom_position = (element_top_position + element_height);
			var element_animation_state = '';

			/////////////////////////////////////////////////////////////
		    // Check to see if this current container is within viewport.
		    if ((element_bottom_position > window_top_position) && (element_top_position < window_bottom_position)) 
		    {
		    	element_animation_state = element.hasClass('ong-in-view') ? 'show' : 'start';
		    	element.addClass('ong-in-view');

		    }
		    else
		    {
		    	element_animation_state = element.hasClass('ong-in-view') ? 'stop' : false;
		    	element.removeClass('ong-in-view');
		    }

		    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		    // Если для текущего блока определен флаг запуска функции-анимации, то проверяем, определены ли для текущего элемента обработчики анимации.
		    if (element_animation_state)
		    {
		  		///////////////////////////////////////////////////////////////////////////
		  		// Проверяем наличие у текущего элемента директив запуска функции анимации.
		  		if (typeof(element.data('ong_animation_exec_funcs')) !== 'undefined')
		  		{
		  			var execFuncs = element.data('ong_animation_exec_funcs').split(':');

		  			//////////////////////////////////////////////////////////////////////////////
		  			// Если обнаружен список функций для запуска, то производим их поиск и запуск.
		  			if (execFuncs && typeof(execFuncs) === 'object' && execFuncs.length > 0)
		  			{
		  				for (var i = 0; i < execFuncs.length; i++)
		  				{
		  					if (typeof(ongPageAnimationHandlers[execFuncs[i]]) === 'function')
		  					{
		  						ongPageAnimationHandlers[execFuncs[i]]( element, element_animation_state, element_top_position, element_bottom_position, window_top_position, window_bottom_position );
		  					}
		  				}
		  			}
		  		}
		  	}
		  });
	}

	/////////////////////////////////////////////////////////////////////////////
	// Определяем обработчик определения отображаемых в текущий момент элементов.
	$(window).on('scroll resize', checkIfElemInView);

	/////////////////////////////////////////////////////////////////////
	// Вешаем обработчик изменения высоты меню-блока на изменение экрана.
	$(window).on('resize', function(event)
	{
		var winWidth = $(window).width();
		var winHeight = $(window).height();

        ///////////////////////////////////////////////
        // Дополнительная обработка мобильного шаблона.
        if (winWidth < 780)
        {
        	$('body').addClass('mobileStyle').removeClass('desktopStyle');
        }
        else
        {
        	$('body').addClass('desktopStyle').removeClass('mobileStyle');
        }
    });

	///////////////////////////////////
	// Дергаем события scroll и resize.
	$(window).trigger('scroll');
	$(window).trigger('resize');	
	
	
	// Слайдер на концерты и акции бара
	function getGroupSlider() {
		var windowsWidth = jQuery(window).width();
		var itemWidth = jQuery('.group').width();

		jQuery('.concert').each(function(){
			var totalCount = jQuery(this).find('.group').length;
			var groupInner = jQuery(this).find('.concert__group-wrapper').html();
			jQuery(this).find('.concert__group-inner').html('');

			if(windowsWidth < 740) {
				jQuery(this).find('.group').eq(0).addClass('group--active');
				var activeIndex = jQuery(this).find('.group--active').index() + 1;		

				jQuery(this).find('.concert__group-wrapper').html('<div class="concert__group-inner">' + groupInner + '</div><div class="pagination"><span class="pagination__arrow pagination__arrow--prev"></span><span class="pagination__current">'+ activeIndex +'</span> / <span class="pagination__total">'+ totalCount +'</span><span class="pagination__arrow pagination__arrow--next"></span></div>');
				jQuery(this).find('.group').eq(0).addClass('group--active');
			} else {
				jQuery(this).find('.concert__group-wrapper').html(groupInner);
			}
		});

		jQuery('.pagination__arrow--next').on('click', function(){
			var totalCount = jQuery(this).parents('.concert').find('.group').length;
			activeIndex = jQuery(this).parents('.concert').find('.group--active').index();
			if (activeIndex < totalCount - 1) {				
				jQuery(this).parents('.concert').find('.group').removeClass('group--active');
				var position = 0 - itemWidth * (activeIndex + 1);
				activeIndex = activeIndex + 1;
				jQuery(this).parents('.concert').find('.group').eq(activeIndex).addClass('group--active');
				jQuery(this).parents('.concert').find('.pagination__current').text(activeIndex + 1);
				jQuery(this).parents('.concert').find('.concert__group-inner').css('left',position + 'px');
			}
		});

		jQuery('.pagination__arrow--prev').on('click', function(){
			var totalCount = jQuery(this).parents('.concert').find('.group').length;
			activeIndex = jQuery(this).parents('.concert').find('.group--active').index();
			if (activeIndex > 0) {				
				jQuery(this).parents('.concert').find('.group').removeClass('group--active');
				var position = 0 - itemWidth * (activeIndex - 1);
				activeIndex = activeIndex - 1;
				jQuery(this).parents('.concert').find('.group').eq(activeIndex).addClass('group--active');
				jQuery(this).parents('.concert').find('.pagination__current').text(activeIndex + 1);
				jQuery(this).parents('.concert').find('.concert__group-inner').css('left',position + 'px');
			}
		});
	}

	jQuery(document).ready(getGroupSlider);
	// jQuery(window).resize(getGroupSlider);


	function langSet() {
		var lang = jQuery('.lang');
		lang.detach();
		lang.css('opacity','1');
		lang.appendTo('.first_elem_wrapper');
	}
	jQuery(document).ready(langSet);


	jQuery(function() {
		jQuery('.mainSiteMenuToggleButton').on('click', function(){
			jQuery('.first_elem_wrapper').toggleClass('first_elem_wrapper--active');
		});
	});

	function menuFix () {
		var windowsWidth = jQuery(window).width();
		if (windowsWidth < 992) {
			jQuery('.first_elem_wrapper').css('display','none');
		} else {
			jQuery('.first_elem_wrapper').css('display','flex');
		}
	};
	jQuery(window).resize(menuFix);

	function scrollHeader () {
		var scroll = jQuery('#ongAlterBodyBlock').scrollTop();
		if(scroll > 150) {
			$('#ongFixedHeaderBlock').addClass('header-bgr');
		} else {
			$('#ongFixedHeaderBlock').removeClass('header-bgr');
		}
	}
	jQuery(document).ready(scrollHeader);
	jQuery('#ongAlterBodyBlock').scroll(scrollHeader);

	/* Паралакс рожи в дырке */
	function holeFaceParalax () {
		if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_home')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_home'))) {
			var scroll = jQuery('body').scrollTop();
			var itemScroll = jQuery('.hole').offset().top;
			var x = itemScroll / 30 + 50;
			// jQuery('.hole__face').css('top',x + '%');
			// jQuery('.hole__text-wrapper').css('top', 1.3 * x + '%');
		}
	}
	jQuery(window).scroll(holeFaceParalax);

	/* Паралакс элементов оформления на главной */
	jQuery('body').mousemove(function(e){
		var windowsWidth = jQuery(window).width();
		if (windowsWidth > 800) {
			var y = (e.pageY / jQuery(window).height());
			var x = (e.pageX / jQuery(window).width());
			if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_home')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_home'))) {
				jQuery('.promo__top-1').css('top', (- 20 * y) +'px');
				jQuery('.promo__top-2').css('top', (10 * y) +'px');
				jQuery('.promo__top-3').css('top', (7 * y + 60) +'%');
				jQuery('.promo__halloween.home').css('top', (-10 * y + 75) +'%');
				jQuery('.promo__main-title-img-wrapper').css('top', (10 * y) +'px');
				jQuery('.promo__main-title-img').css('top', (-20 * y) +'px');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_bankety')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_bankety'))) {
				jQuery('.promo__bankets-1').css('bottom', (- 20 * y) +'px');
				jQuery('.promo__bankets-2').css('top', (- 10 * y) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_cafe')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_cafe'))) {
				jQuery('.promo__bar-1').css('bottom', (20 * y) +'px');
				jQuery('.cafe-menu__text--block').css('top', (- 20 * y) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_bar')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_bar'))) {
				jQuery('.promo__bar-1').css('bottom', (20 * y) +'px');
				jQuery('.cafe-menu__text--block').css('top', (- 20 * y) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_nightspot')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_nightspot'))) {
				jQuery('.promo__club-1').css('bottom', (-30 * y - 15) +'px');
				jQuery('.promo__club-2').css('top', (- 10 * y) +'px');
				jQuery('.promo__club-3').css('bottom', (25 * y) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_kontakty')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_kontakty'))) {
				jQuery('.promo__contacts-1').css('top', (- 20 * y) +'px');
				jQuery('.promo__contacts-2').css('top', (10 * y + 500) +'px');
				jQuery('.promo__contacts-3').css('top', (- 20 * y) +'px');
				jQuery('.promo__contacts-4').css('top', (10 * y + 500) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_foto')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_foto'))) {
				jQuery('.promo__photo-1').css('top', (- 20 * y) +'px');
				jQuery('.promo__photo-2').css('top', (10 * y + 500) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_halloween')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_halloween'))) {
				jQuery('.promo__halloween-1').css('top', (- 20 * y) +'px');
				jQuery('.promo__halloween-2').css('top', (10 * y + 650) +'px');
				jQuery('.promo__halloween.all').css('top', (-50 * y + 10) +'%');
			} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_new_year')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_new_year'))) {
				// jQuery('.promo__new_year-1').css('top', ( -20 * y + 350) +'px');
				// jQuery('.promo__new_year-2').css('top', (10 * y + 80) +'px');

				jQuery('.promo__top-1').css('top', ( -20 * y - 20) +'px');
				jQuery('.promo_hand').css('top', (7 * y + 70) +'%');

				jQuery('.paralax_layer_1').css({'top':( -2 * y + 50) +'%','left':( -2 * x + 50) +'%'});
				jQuery('.paralax_layer_2').css('left', ( x + 50) +'%');
			}
		}
	});

	function scrollFunction () {
		var windowsWidth = jQuery(window).width();
		var slideItems = [];
		var slideItemsScroll = [];
		var positionType = [];
		$('.slide_item').each(function(indx, element){
			var itemPosition = parseInt(jQuery(this).css('left'));
			if(itemPosition < (windowsWidth / 2)) {
				slideItems.push(parseInt(jQuery(this).css('left')));
				positionType.push('left');
			} if(itemPosition > (windowsWidth / 2)) {
				slideItems.push(parseInt(jQuery(this).css('right')));
				positionType.push('right');
			}
			slideItemsScroll.push($(element).offset().top);
		});
		var itemsSlide = $('.slide_item').map(function(){
			return this;
		}).get();
		for(var i = 0; i<slideItems.length; i++) {
			if (positionType[i] == 'left') {
				jQuery(itemsSlide[i]).css(positionType[i],'-999px');	
			} if (positionType[i] == 'right') {
				jQuery(itemsSlide[i]).css(positionType[i],'-999px');	
			}			
		}
		jQuery(window).on('scroll', function() {
			var scroll = jQuery(window).scrollTop();

			for(var i = 0; i<slideItems.length; i++) {
				if (scroll > slideItemsScroll[i] - 600) {
					if(slideItems[i] < (windowsWidth / 2)) { jQuery(itemsSlide[i]).css(positionType[i], slideItems[i]+'px'); } 
				} else {
					// if(slideItems[i] < (windowsWidth / 2)) { jQuery(itemsSlide[i]).css(positionType[i],'-999px');; } 
				}
			}
		});

		
		var paralaxItems = [];
		$('.paralax_item').each(function(indx, element){
			paralaxItems.push($(element).offset().top - $(element).height());
		});
		var items = $('.paralax_item').map(function(){
			return this;
		}).get();
		jQuery(window).on('scroll', function() {
			var scroll = jQuery(window).scrollTop();
			for(var i = 0; i<paralaxItems.length; i++) {
				var delta = paralaxItems[i] - scroll / 6 + 100;
				// jQuery(items[i]).css('top', delta + 'px');
			}
		});
	}
	jQuery(document).ready(scrollFunction);
	jQuery(window).resize(scrollFunction);
	

	function holeBGRphoto() {
		var windowsWidth = jQuery(window).width();
		if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_cafe')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_cafe'))) {
			if (windowsWidth < 992) {
				var position1 = parseInt(jQuery('#BarCafeClub').position().top + jQuery('#BarCafeClub').height() + 50);
			} else {
				var position1 = parseInt(jQuery('#BarCafeClub').position().top + jQuery('#BarCafeClub').height() - 50);
			}

			if(jQuery('.cafe-menu__wrapper-item')) {
				var position2 = parseInt(jQuery('.cafe-menu__wrapper-item').position().top + jQuery('.cafe-menu__wrapper-item').height() + jQuery('#BarCafeClub').position().top + jQuery('#BarCafeClub').height() + parseInt(jQuery('#BarCafeClub').css('margin-bottom')) + 320);
				jQuery('.cafe-menu__barmen-1').css('top', position1 + 'px');			
				jQuery('.cafe-menu__barmen-2').css('top', position2 + 'px');

				console.log(position1);
			}
			
		} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_bar')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_bar'))) {
			var position1 = parseInt(jQuery('#BarCafeClub').position().top + jQuery('#BarCafeClub').height() + 160);
			var position2 = parseInt(jQuery('.bar-menu').position().top + jQuery('.bar-menu').height() + jQuery('#BarCafeClub').position().top + jQuery('#BarCafeClub').height() + parseInt(jQuery('#BarCafeClub').css('margin-bottom')) - 420);
			jQuery('.bar-menu__barmen-1').css('top', position1 + 'px');			
			jQuery('.bar-menu__barmen-2').css('top', position2 + 'px');
		} if ((jQuery('#ongAlterBodyBlock').hasClass('pgBlock_nightspot')) || (jQuery('#ongAlterBodyBlock').hasClass('pgBlock_en_nightspot'))) {
			if (windowsWidth < 992) {
				var position1 = parseInt(jQuery('.club-anonce__bgr-wrapper').height() - jQuery('.places').height() - jQuery('.club-anonce__club-1').height() - 30);	
			} else {
				var position1 = parseInt(jQuery('.club-anonce__bgr-wrapper').height() - jQuery('.places').height() - jQuery('.club-anonce__club-1').height() + 200);
			}			
			jQuery('.club-anonce__club-1').css('top', position1 + 'px');	
		}

	}
	jQuery(document).ready(holeBGRphoto);
	jQuery(window).resize(holeBGRphoto);
	



	// Переключение табов расписания на главной странице

	var mySwiper = new Swiper('#scheduleSlider', {
		slidesPerView: 1,
		speed: 400,
		touch: false,
		loop: false,
		spaceBetween: 0
	});

	function getScheduleTabs() {
		if($('.promo').hasClass('schedule')) {
			var tabId = 0;
			var date = date || new Date();
			var daysIdArr = ['6','0','1','2','3','4','5'];
			var day = date.getDay();

			tabId = daysIdArr[day];

			$('.day_item, .day_content').removeClass('active');
			$('.day_item').eq(tabId).addClass('active');
			mySwiper.slideTo(tabId, 300, false);

			$('.day_item').on('click', function(e){
				tabId = $(this).index();

				$('.day_item, .day_content').removeClass('active');
				$('.day_item').eq(tabId).addClass('active');

				mySwiper.slideTo(tabId, 300, false);

				// $('.day_content').eq(tabId).addClass('active');
			})
		}
	}
	getScheduleTabs();





	$('.js_get_popup').on('click', function(e){
		e.preventDefault();

		$('#js_popup_form').addClass('visible');
		$('#js_popup_bgr').addClass('visible');
	});


	$('.js_close_popup, #js_popup_bgr').on('click', function(e){
		e.preventDefault();

		$('#js_popup_form').removeClass('visible');
		$('#js_popup_bgr').removeClass('visible');
	});





































//   // ---------
//   // Functions
//   // ---------

//   var canvas = document.querySelector('canvas');
//   canvas.width = document.body.clientWidth;
//   canvas.height = document.body.clientHeight;
//   var ctx = canvas.getContext('2d');
//   var count = canvas.height;
//   var bubbles = [];
//   var bubbleCount = 25;
//   var bubbleSpeed = 1;
//   var popLines = 3;
//   var popDistance = 20;
//   var mouseOffset = { 
//   	x: 0,
//   	y: 0
//   }



//   // --------------
//   // Animation Loop
//   // --------------

//   function animate() {



//     // ------------
//     // Clear Canvas
//     // ------------

//     ctx.clearRect(0, 0, canvas.width, canvas.height);



//     // ------------
//     // Draw Bubbles
//     // ------------

//     ctx.beginPath();
//     for (var i = 0; i < bubbles.length; i++) {
//       // first num = distance between waves
//       // second num = wave height
//       // third num = move the center of the wave away from the edge
//       bubbles[i].position.x = Math.sin(bubbles[i].count/bubbles[i].distanceBetweenWaves) * 50 + bubbles[i].xOff;
//       bubbles[i].position.y = bubbles[i].count;
//       bubbles[i].render();

//       if(bubbles[i].count < 0 - bubbles[i].radius) {
//       	bubbles[i].count = canvas.height + bubbles[i].yOff;
//       } else {
//       	bubbles[i].count -= bubbleSpeed;
//       }
//   }

//     // ---------------
//     // On Bubble Hover
//     // ---------------

//     for (var i = 0; i < bubbles.length; i++) {
//     	if(mouseOffset.x > bubbles[i].position.x - bubbles[i].radius && mouseOffset.x < bubbles[i].position.x + bubbles[i].radius) {
//     		if(mouseOffset.y > bubbles[i].position.y - bubbles[i].radius && mouseOffset.y < bubbles[i].position.y + bubbles[i].radius) {
//     			for (var a = 0; a < bubbles[i].lines.length; a++) {
//     				popDistance = bubbles[i].radius * 0.5;
//     				bubbles[i].lines[a].popping = true;
//     				bubbles[i].popping = true;
//     			}
//     		}
//     	}
//     }

//     window.requestAnimationFrame(animate);
// }

// window.requestAnimationFrame(animate);



//   // ------------------
//   // Bubble Constructor
//   // ------------------

//   var createBubble = function() {
//   	var winWidth = $(window).width();

//   	this.position = {x: 0, y: 0};
//   	if(winWidth < 700) {this.radius = 1 + Math.random() * 10;} 
//   	else {this.radius = 1 + Math.random() * 20;}
//   	this.xOff = Math.random() * canvas.width - this.radius;
//   	this.yOff = Math.random() * canvas.height;
//   	this.distanceBetweenWaves = 50 + Math.random() * 40;
//   	this.count = canvas.height + this.yOff;
//   	this.color = '#fff';
//   	this.fillStyle = '#fff';
//   	this.lines = [];
//   	this.popping = false;
//   	this.maxRotation = 85;
//   	this.rotation = Math.floor(Math.random() * (this.maxRotation - (this.maxRotation * -1))) + (this.maxRotation * -1);
//   	this.rotationDirection = 'forward';

//     // Populate Lines
//     for (var i = 0; i < popLines; i++) {
//     	var tempLine = new createLine();
//     	tempLine.bubble = this;
//     	tempLine.index = i;

//     	this.lines.push(tempLine);
//     }

//     this.resetPosition = function() {
//     	this.position = {x: 0, y: 0};
//     	this.radius = 8 + Math.random() * 6;
//     	this.xOff = Math.random() * canvas.width - this.radius;
//     	this.yOff = Math.random() * canvas.height;
//     	this.distanceBetweenWaves = 50 + Math.random() * 40;
//     	this.count = canvas.height + this.yOff;
//     	this.popping = false;
//     }

//     // Render the circles
//     this.render = function() {
//     	if(this.rotationDirection === 'forward') {
//     		if(this.rotation < this.maxRotation) {
//     			this.rotation++;
//     		} else {
//     			this.rotationDirection = 'backward';
//     		}
//     	} else {
//     		if(this.rotation > this.maxRotation * -1) {
//     			this.rotation--;
//     		} else {
//     			this.rotationDirection = 'forward';
//     		}
//     	}

//     	ctx.save();
//     	ctx.translate(this.position.x, this.position.y);
//     	ctx.rotate(this.rotation*Math.PI/180);

//     	if(!this.popping) {
//     		ctx.fillStyle = "#fff";
//     		ctx.beginPath();
//     		ctx.strokeStyle = '#fff';
//     		ctx.lineWidth = 1;
//     		ctx.beginPath();
//     		ctx.arc(0, 0, this.radius, 0, Math.PI*2, false);
//     		ctx.fill();
//     		ctx.stroke();
//     	}

//     	ctx.restore();

//       // Draw the lines
//       for (var a = 0; a < this.lines.length; a++) {
//       	if(this.lines[a].popping) {
//       		if(this.lines[a].lineLength < popDistance && !this.lines[a].inversePop) {
//       			this.lines[a].popDistance += 0.06;
//       		} else {
//       			if(this.lines[a].popDistance >= 0) {
//       				this.lines[a].inversePop = true;
//       				this.lines[a].popDistanceReturn += 1;
//       				this.lines[a].popDistance -= 0.03;
//       			} else {
//       				this.lines[a].resetValues();
//       				this.resetPosition();
//       			}
//       		}

//       		this.lines[a].updateValues();
//       		this.lines[a].render();
//       	}
//       }
//   }
// }



//   // ----------------
//   // Populate Bubbles
//   // ----------------

//   for (var i = 0; i < bubbleCount; i++) {
//   	var tempBubble = new createBubble();

//   	bubbles.push(tempBubble);
//   }



//   // ----------------
//   // Line Constructor
//   // ----------------

//   function createLine() {
//   	this.lineLength = 0;
//   	this.popDistance = 0;
//   	this.popDistanceReturn = 0;
//     this.inversePop = false; // When the lines reach full length they need to shrink into the end position
//     this.popping = false;

//     this.resetValues = function() {
//     	this.lineLength = 0;
//     	this.popDistance = 0;
//     	this.popDistanceReturn = 0;
//     	this.inversePop = false;
//     	this.popping = false;

//     	this.updateValues();
//     }

//     this.updateValues = function() {
//     	this.x = this.bubble.position.x + (this.bubble.radius + this.popDistanceReturn) * Math.cos(2 * Math.PI * this.index / this.bubble.lines.length);
//     	this.y = this.bubble.position.y + (this.bubble.radius + this.popDistanceReturn) * Math.sin(2 * Math.PI * this.index / this.bubble.lines.length);
//     	this.lineLength = this.bubble.radius * this.popDistance;
//     	this.endX = this.lineLength;
//     	this.endY = this.lineLength;
//     }

//     this.render = function() {
//     	this.updateValues();

//     	ctx.beginPath();
//     	ctx.strokeStyle = '#fff';
//     	ctx.fillStyle = '#fff';
//     	ctx.lineWidth = 2;
//     	ctx.moveTo(this.x, this.y);
//     	if(this.x < this.bubble.position.x) {
//     		this.endX = this.lineLength * -1;
//     	}
//     	if(this.y < this.bubble.position.y) {
//     		this.endY = this.lineLength * -1;
//     	}
//     	if(this.y === this.bubble.position.y) {
//     		this.endY = 0;
//     	}
//     	if(this.x === this.bubble.position.x) {
//     		this.endX = 0;
//     	}
//     	ctx.lineTo(this.x + this.endX, this.y + this.endY);
//     	ctx.stroke();
//     };
// }



//   // ---------------
//   // Event Listeners
//   // ---------------

//   canvas.addEventListener('mousemove', mouseMove);

//   function mouseMove(e) {
//   	mouseOffset.x = e.offsetX;
//   	mouseOffset.y = e.offsetY;
//   }

//   window.addEventListener('resize', function() {
//   	canvas.width = document.body.clientWidth;
//   	canvas.height = document.body.clientHeight;
//   });


  // ---------------
  // Event Listeners
  // ---------------


});
